import m from "mithril"
import "./Loader.scss"

export class Loader {
  view(v) {
    return <div className="loader">
      <div className="lds-ripple">
        <div /><div /><div />
      </div>
    </div>
  }
}